import { render, staticRenderFns } from "./sale-target-config.vue?vue&type=template&id=19e63c92&scoped=true&"
import script from "./sale-target-config.vue?vue&type=script&lang=js&"
export * from "./sale-target-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e63c92",
  null
  
)

export default component.exports